import connection from '../connection';

export const getUserEnrollments = async params =>
   connection.get('v1/current_user/enrollments', params);

export const getActiveEnrollments = async =>
   connection.get('v1/current_user/enrollments/list_enrollments');

export const getActiveEnrollmentDetails = async id =>
   connection.get('v1/current_user/enrollments/' + id + '/active_enrollment_details');

export const getLeaguePlayerADetails = async enrollmentId =>
    connection.get(`v1/current_user/enrollments/${enrollmentId}/player_a_details`);

export const getLeaguePlayerBDetails = async enrollmentId =>
    connection.get(`v1/current_user/enrollments/${enrollmentId}/player_b_details`);

export const getTournamentEnrollments = async =>
   connection.get('v1/current_user/tournament_enrollments');

export const getTournamentEnrollmentDetails = async id =>
   connection.get(`v1/current_user/tournament_enrollments/${id}/details`);

export const getTournamentPlayerADetails = async tournamentEnrollmentId =>
    connection.get(`v1/current_user/tournament_enrollments/${tournamentEnrollmentId}/player_a_details`);

export const getTournamentPlayerBDetails = async tournamentEnrollmentId =>
    connection.get(`v1/current_user/tournament_enrollments/${tournamentEnrollmentId}/player_b_details`);

export const getOffersForTournament = async super_tournament_id =>
   await connection.get("v1/leagues/offer_types.json", {super_tournament_id: super_tournament_id});

export const getOffersForLeague = async league_edition_id =>
   await connection.get("v1/leagues/offer_types.json", {league_edition_id: league_edition_id});

export const changeOffersEnrollment = async (id, params) =>
   connection.post('v1/current_user/enrollments/' + id + '/change_offers', params);

export const changeTournamentOffers = async (id, params) =>
   connection.post('v1/current_user/tournament_enrollments/' + id + '/change_offers', params);

export const getAvailabilities = async enrollmentId =>
   connection.get(`v1/current_user/enrollments/${enrollmentId}/availabilities`);

export const changeAvailabilities = async (enrollmentId, availabilities)=>
   connection.post(`v1/current_user/enrollments/${enrollmentId}/change_availabilities`, {availabilities});

export const getRanking = async (leagueEditionId, leagueId, leagueCategoryId, leagueDivisionId) =>
   connection.get('v1/current_user/rankings', {league_edition_id: leagueEditionId, league_id: leagueId, league_category_id: leagueCategoryId, league_division_id: leagueDivisionId});

export const registerAbsence = async (enrollmentId, reason, absenceStartDate, absenceEndDate) =>
   connection.post(`v1/current_user/enrollments/${enrollmentId}/register_absence`, {absence_reason: reason, absence_start_date: absenceStartDate, absence_end_date: absenceEndDate});

export const registerReturn = async (enrollmentId) =>
   connection.post(`v1/current_user/enrollments/${enrollmentId}/register_return`);
